import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

import Box from './Box'

const Wrapper = ({ handleStep, handleStepOnMode, address }) => {
  function addAddress () {
    handleStep(1)
    handleStepOnMode('add')
  }

  return (
    <div className='pt-3 d-flex bg-ui-4 border-color-ui-3 border-bottom flex-wrap justify-content-center justify-content-md-start'>
      <Box
        address={address}
        handleStep={handleStep}
        handleStepOneMode={handleStepOnMode} />
      <a className='col-md-5 col-11 p-0 mx-3 mb-3 py-5 color-brand-2-like border-brand-2 border-dashed-lg p-2 d-flex flex-column justify-content-center align-items-center'
        onClick={addAddress}>
        <Icon iconName='icon_add' className='color-brand-2-like mb-1' />
        <p>
          <strong>Cadastrar novo endereço</strong>
        </p>
      </a>
    </div>
  )
}

Wrapper.propTypes = {
  handleStep: PropTypes.func,
  handleStepOnMode: PropTypes.func,
  address: PropTypes.object
}

export default Wrapper



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Address/Wrapper.js